"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAgent = void 0;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var UserAgent = (function () {
    function UserAgent() {
        var parser = new ua_parser_js_1.default();
        this.ua = parser.getResult();
    }
    Object.defineProperty(UserAgent.prototype, "connection", {
        get: function () {
            var _a, _b, _c, _d, _e;
            if (!navigator.connection) {
                return {
                    connection_type: 'unknown',
                };
            }
            return {
                connection_type: ((_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType) ||
                    ((_b = navigator.connection) === null || _b === void 0 ? void 0 : _b.type) ||
                    'unknown',
                connection_downlink: ((_c = navigator.connection) === null || _c === void 0 ? void 0 : _c.downlink)
                    ? ((_d = navigator.connection) === null || _d === void 0 ? void 0 : _d.downlink) * 1024
                    : -1,
                connection_rtt: (_e = navigator.connection) === null || _e === void 0 ? void 0 : _e.rtt,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "browser", {
        get: function () {
            var _a, _b, _c, _d;
            return {
                browser: this.ua.ua,
                browser_name: (_a = this.ua.browser.name) !== null && _a !== void 0 ? _a : '',
                browser_version: (_b = this.ua.browser.version) !== null && _b !== void 0 ? _b : '',
                engine_name: (_c = this.ua.engine.name) !== null && _c !== void 0 ? _c : '',
                engine_version: (_d = this.ua.engine.version) !== null && _d !== void 0 ? _d : '',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "screen", {
        get: function () {
            var _a;
            return {
                screen_dpr: window.devicePixelRatio
                    ? parseFloat(window.devicePixelRatio.toFixed(2))
                    : undefined,
                screen_height: window.screen.height,
                screen_width: window.screen.width,
                orientation: ((_a = window.screen.orientation) === null || _a === void 0 ? void 0 : _a.type) || '',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "device", {
        get: function () {
            var _a, _b, _c;
            return {
                os_name: this.ua.os.name,
                os_version: this.ua.os.version,
                device_name: (_b = (_a = this.ua.device) === null || _a === void 0 ? void 0 : _a.model) !== null && _b !== void 0 ? _b : (_c = this.ua.device) === null || _c === void 0 ? void 0 : _c.type,
                device_id: '',
            };
        },
        enumerable: false,
        configurable: true
    });
    return UserAgent;
}());
exports.UserAgent = UserAgent;
